import React, {FC} from 'react'
import {useProducts} from '../../contexts/ProductsProvider'
import {Card} from '../../modules/all-pages'
import RequestAProductButton from '../../contexts/RequestAProductButton'

const Products = () => <Card id={'products'} title={'Produits'}><Body /></Card>

const Body: FC = () => {
    const {productsActive, productsList, isLoading} = useProducts()

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center py-10">
                <span className="spinner-border spinner-border-lg text-primary" />
            </div>
        )
    }


    return (
        <>
            {productsList.map((item, index) => {
                const product = productsActive[item.name]

                const isActive = !!product?.activated_at
                const description = item.description || ''
                const date = product?.activated_at || ''

                console.log(
                    product.name,
                    isActive
                )

                if (!isActive) return null

                return (
                    <div key={item.id} className="row mb-5">
                        {/* Status indicator and title */}
                        <div className="col-xl-6 col-sm-5 col-10 d-flex align-items-center">
                            <span
                                className={`bullet bullet-vertical h-40px me-7 bg-${isActive ? 'success' : 'danger'}`} />
                            <div className="d-flex flex-column">
                                <span className="text-gray-800 fw-bolder fs-6 align-items-center">{item.name}</span>
                                {/*<span className="text-gray-600 fs-7">*/}
                                {/*    {item.id} {description ? `- ${description}` : ''}*/}
                                {/*</span>*/}
                            </div>
                        </div>

                        {/* Active/Inactive badge */}
                        <div
                            className="col-xl-2 col-sm-2 col-2 d-flex align-items-center justify-content-sm-center justify-content-end">
                          <span
                              className={`badge fs-8 fw-bolder text-capitalize badge-light-${isActive ? 'success' : 'danger'}`}>{isActive ? 'actif' : 'inactif'}</span>
                        </div>

                        {/* Action or date */}
                        <div className="col-xl-4 col-sm-5 col-12 d-flex justify-content-end align-items-center">
                            {!isActive ? (
                                <RequestAProductButton name={item.name}
                                                       productKey={item.name}
                                                       description={description}
                                                       index={index}
                                />
                            ) : (
                                /* Produit actif, afficher la date */
                                <span className="">{date}</span>
                            )}
                        </div>
                    </div>
                )
            })}
        </>
    )
}

export {Products}
